import { Object3D, Mesh, Group, Vector3, Quaternion } from "three";

// 当删除原始模型时需要检测该模型是否有复制体
export class CopyUtil {
  constructor() {
    this.copyRecord = []; // 保存所有的复制体
  }

  clear() {
    this.copyRecord = [];
  }

  /**
   * 阵列复制模型
   * @param {*} objs 原模型，可以是单个模型，也可以是模型数组
   * @param {*} row 阵列的行数，x轴
   * @param {*} col 阵列的列数，z轴
   * @param {*} offset 间隔，m
   */
  copy(objs, row = 1, col = 1, offset = 1, cb = null, modelId = null) {
    if (!objs) return;
    if (!Array.isArray(objs)) objs = [objs];

    for (let i = 0; i < row; i++) {
      for (let j = 0; j < col; j++) {
        for (let k = 0; k < objs.length; k++) {
          let obj = this._deepCloneObject3D(objs[k]);

          obj.position.copy(objs[k].getWorldPosition(new Vector3()));
          obj.quaternion.copy(objs[k].getWorldQuaternion(new Quaternion()));
          obj.scale.copy(objs[k].getWorldScale(new Vector3()));

          obj.position.x += i * offset;
          obj.position.z += j * offset;
          obj.name = objs[k].name + "_copy(" + (i * row + j) + ")";
          obj.isCopyObj = true;
          this._makeSomeProperties(obj, modelId);
          const record = {
            model: obj,
          };

          // 存储原始模型的引用
          if (objs[k]._copySrcObj) obj._copySrcObj = objs[k]._copySrcObj;
          else obj._copySrcObj = objs[k];
          // 存储原始模型的复制体的引用
          if (!obj._copySrcObj._copys) obj._copySrcObj._copys = [];
          obj._copySrcObj._copys.push(obj);

          //   // 存储原始模型的类型
          //   // 模型文件
          //   if (objs[i]._root && objs[i]._root._modelUrl) {
          //     record.sourceType = objs[i]._root._modelUrl;
          //     obj._modelUrl = objs[i]._root._modelUrl;
          //   }
          //   // 基本几何体
          //   else if (objs[i]._ObjectType) {
          //     record.sourceType = "basicObj_" + objs[i]._ObjectType;
          //     obj._ObjectType = objs[i]._ObjectType;
          //   }

          this.copyRecord.push(record);

          if (cb) cb(obj);
        }
      }
    }
  }

  _deepCloneObject3D(object) {
    if (!object) return;
    // 创建新的 Object3D
    let clonedObject = new Object3D();

    if (object.isGroup) {
      clonedObject = new Group();
    } else if (object.isMesh) {
      clonedObject = new Mesh(object.geometry, object.material);
      clonedObject.castShadow = object.castShadow; // 物体投射阴影
      clonedObject.receiveShadow = object.receiveShadow; // 地面接收阴影
    }

    // 复制基本属性
    clonedObject.position.copy(object.position);
    clonedObject.rotation.copy(object.rotation);
    clonedObject.scale.copy(object.scale);
    clonedObject.name = object.name;
    //clonedObject.userData = JSON.parse(JSON.stringify(object.userData)); // 深拷贝 userData 这个会死循环报警告
    if (object.userData.modelFrom)
      clonedObject.userData = {
        modelFrom: object.userData.modelFrom,
      };

    // 遍历子对象并递归克隆
    object.children.forEach((child) => {
      const clonedChild = this._deepCloneObject3D(child); // 递归克隆子对象
      clonedObject.add(clonedChild);
    });

    return clonedObject;
  }

  /**
   * 设置一些模型的属性，以便与其它模型操作统一
   */
  _makeSomeProperties(obj, srcModelId = null) {
    if (!obj) return;

    const modelId = srcModelId ? srcModelId : obj.uuid;

    let count = -1;
    obj.traverse((node) => {
      node.modelId = modelId;
      node.nodeId = modelId + "|" + count;
      count++;
      node._root = obj;

      // 材质默认使用原先的
      //   if (node.material) {
      //     node.material.modelId = modelId;
      //     node.material.matId = node.nodeId;
      //   }
    });
  }

  /**
   * 设置跟据nodeId获取模型的回调函数
   * @param {*} cb
   */
  setGetModelCB(cb) {
    this.getModelCB = cb;
  }

  deleteByModelId(modelId) {
    for (var i = 0; i < this.copyRecord.length; i++) {
      if (this.copyRecord[i].model.modelId === modelId) {
        const srcModel = this.copyRecord[i].model._copySrcObj;
        this.copyRecord[i].model._record = this.copyRecord[i];
        if (srcModel) {
          if (srcModel._copys) {
            const index = srcModel._copys.indexOf(this.copyRecord[i].model);
            if (index >= 0) srcModel._copys.splice(index, 1);
          }
        }

        this.copyRecord.splice(i, 1);
        break;
      }
    }
  }

  save() {
    const res = [];
    for (let i = 0; i < this.copyRecord.length; i++) {
      const record = {
        srcNodeId: this.copyRecord[i].model._copySrcObj.nodeId,
        modelId: this.copyRecord[i].model.modelId,
        name: this.copyRecord[i].model.name,
        pos: this.copyRecord[i].model.position.clone(),
        quat: this.copyRecord[i].model.quaternion.clone(),
        scale: this.copyRecord[i].model.scale.clone(),
        visible: this.copyRecord[i].model.visible,
      };
      res.push(record);
    }

    return res;
  }

  restore(info, addToSceneCB) {
    if (!info || !Array.isArray(info)) return;
    if (!this.getModelCB) {
      console.error("请设置获取模型的回调函数");
      return;
    }
    for (var i = 0; i < info.length; i++) {
      let srcObj = this.getModelCB(info[i].srcNodeId);
      if (!srcObj) {
        console.error("找不到模型：" + info[i].srcNodeId);
        continue;
      }
      this.copy(
        srcObj,
        1,
        1,
        1,
        (obj) => {
          obj.name = info[i].name;
          obj.position.set(info[i].pos.x, info[i].pos.y, info[i].pos.z);
          obj.quaternion.fromArray(info[i].quat);
          obj.scale.set(info[i].scale.x, info[i].scale.y, info[i].scale.z);
          obj.visible = info[i].visible;
          addToSceneCB(obj);
        },
        info[i].modelId
      );
    }
  }
}
